/* Complete replacement for the supplied vehicle/fitment script.
 * Keep the existing theme markup and cart submission code.
 * Load once, with defer or after the product markup.
 */
function onReady(callback) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true });
  } else callback();
}

let fitmentNeedsVerification = false;
const vehiclePropertyKeys = ['Year', 'Make', 'Model', 'Fits'];
function vehicleProperties() {
  const read = (key, placeholder) => {
    const value = (sessionStorage.getItem(key) || '').trim();
    return value.toLowerCase() === placeholder.toLowerCase() ? '' : value;
  };
  const Year = read('selectedYear', 'Year');
  const Make = read('selectedMake', 'Make');
  const Model = read('selectedModel', 'Model');
  return { Year, Make, Model, Fits: Year && Make && Model ? `${Year}/${Make}/${Model}` : '' };
}
function productForms() {
  return [...document.querySelectorAll('form.shopify-product-form, .shopify-product-form form, form[action*="/cart/add"]')];
}
function writeProperties(target, values) {
  for (const [key, raw] of Object.entries(values)) {
    const value = String(raw || '').trim();
    const matches = [...target.querySelectorAll('input')].filter(input => input.name === `properties[${key}]`);
    let input = matches.shift();
    matches.forEach(duplicate => duplicate.remove());
    if (!value) { input?.remove(); continue; }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${key}]`;
      input.dataset.auto = 'true';
      target.appendChild(input);
    }
    input.disabled = false;
    if (input.value !== value) input.value = value;
    if (input.dataset.value !== value) input.dataset.value = value;
    if (input.dataset.fieldName !== key) input.dataset.fieldName = key;
  }
}
function syncVehicleCartProperties() {
  const values = vehicleProperties();
  const forms = productForms();
  for (const form of forms) {
    // Keep fields in the submitted form and in the app container when available.
    let target = form.querySelector('[data-vehicle-cart-properties]');
    if (!target) {
      target = document.createElement('div');
      target.hidden = true;
      target.dataset.vehicleCartProperties = '';
      (form.querySelector('.gpo-hidden-inputs') || form).appendChild(target);
    }
    for (const input of form.querySelectorAll('input')) {
      if (!target.contains(input) && vehiclePropertyKeys.some(key => input.name === `properties[${key}]`)) input.remove();
    }
    writeProperties(target, values);
  }
  // Support existing app code that explicitly reads its hidden-input container.
  // With a form present, form fields are the single canonical copy.
  if (!forms.length) {
    document.querySelectorAll('.gpo-hidden-inputs').forEach(target => writeProperties(target, values));
  }
}
function syncSwatchProperties(swatch) {
  const form = swatch.closest('form') || productForms()[0];
  const target = form?.querySelector('.gpo-hidden-inputs') || form || document.querySelector('.gpo-hidden-inputs');
  if (target) writeProperties(target, {
    Position: swatch.closest('.product-info__rowindex')?.dataset.position || '',
    Style: swatch.previousElementSibling?.value || '',
    Fitment: swatch.querySelector('.fit-dropdown-button .dropdown-title')?.textContent?.trim() || '',
    Sku: swatch.previousElementSibling?.dataset.sku || ''
  });
  syncVehicleCartProperties();
}

let yearSelect = document.getElementById('yearSelect');
let makeSelect = document.getElementById('makeSelect');
let modelSelect = document.getElementById('modelSelect');
let SearchBtnYMM = document.getElementById('ymm-serch-btn');
let VerifyBtnYMM = document.getElementById('ymm-verify-btn');
let ClearBtnYMM = document.getElementById('ymm-clear-btn');

let floor_mats_active = false;
if(document.querySelectorAll('.hide_variant_picker_cls').length > 0){
  floor_mats_active = true;
}

const baseUrl = "https://appdash.dashdesigns.info/api/get-ymm-list";
const probaseUrl = "https://appdash.dashdesigns.info/api/get-ymm-products-rows";

function escapeHTML(value) {
  return String(value ?? '').replace(/[&<>"']/g, char => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  })[char]);
}

function handleize(str) {
  return str
    .toLowerCase()
    .replace(/[()]/g, '')      // remove ( )
    .replace(/[^a-z0-9]+/g, '-') // replace spaces & symbols with -
    .replace(/^-+|-+$/g, '');   // trim hyphens
}
// Validate the actual selected options, independently of button CSS or GPO.
function cleanFitmentValue(value) {
  const text = String(value ?? '').trim();
  return /^(null|undefined)$/i.test(text) ? '' : text;
}

function inspectFitmentRows(wrapper) {
  if (!wrapper) return { error: '', selections: [] };
  if (fitmentNeedsVerification) {
    return { error: 'Please verify your vehicle before adding to cart.', selections: [] };
  }

  const selections = [];
  const rows = wrapper.querySelectorAll(
    '.product-info__rowindex:not(.removed-row-data)'
  );
  for (const row of rows) {
    const input = row.querySelector('.position-select-row input:checked');
    if (!input) {
      // Unselected optional positions are allowed; stale active rows are not.
      if (row.classList.contains('acitve-row-prod')) {
        return { error: 'Please select your product options before adding to cart.', selections: [] };
      }
      continue;
    }
    const swatch = input.nextElementSibling;
    const fitment = cleanFitmentValue(input.getAttribute('data-fitment-val'));
    const sku = cleanFitmentValue(input.getAttribute('data-sku'));
    const requiresFitment = Array.from(
      swatch?.querySelectorAll('.pro-dropdown-menu li') || []
    ).some(option => cleanFitmentValue(option.getAttribute('data-fitval')) !== '');

    if (requiresFitment && !fitment) {
      return { error: 'Select your fitment before adding to cart.', selections: [] };
    }
    if (!sku) {
      return { error: 'The selected option is missing its SKU. Please select it again before adding to cart.', selections: [] };
    }
    selections.push({ row, input, fitment, sku });
  }
  if (!selections.length) {
    return { error: 'Please select Vehicle Fitment before adding to cart.', selections: [] };
  }
  return { error: '', selections };
}

function prepareFitmentRowsForCart(wrapper) {
  const result = inspectFitmentRows(wrapper);
  if (result.error) return result.error;
  // Only update the cart rows after every selected item passes validation.
  for (const { row, input, fitment, sku } of result.selections) {
    row.classList.add('acitve-row-prod');
    row.setAttribute('data-selectfit', fitment);
    row.setAttribute('data-sku', sku);
    row.setAttribute('data-selectstyle', cleanFitmentValue(input.value));
    row.setAttribute('data-fitimage', cleanFitmentValue(input.getAttribute('data-fitment-img')));
  }
  return '';
}

function updateATCButtonState() {
  const wrapper = document.querySelector('.product-grid-fitmentwrapper');
  const atcButton = document.querySelector('.shopify-product-form .buy-buttons button[type="submit"]');
  if (!wrapper || !atcButton) return;
  const { error } = inspectFitmentRows(wrapper);
  atcButton.classList.toggle('disabled', Boolean(error));
  atcButton.classList.toggle('disabledchoose', Boolean(error) && error.includes('Select your fitment'));
}

const selectSoloItem = (data) => {
  if(data.length === 1 && data[0].styles?.length === 1 && data[0].styles[0].fitments?.length === 1) {
    const rowElements = document.getElementsByClassName('position-select-row')

    if(rowElements.length === 1) {
      const fitmentElement = rowElements[0].getElementsByClassName('block-swatch')
      if(fitmentElement.length === 1) {
        const selectedElement = fitmentElement[0]
        selectedElement.click()
      }
    }
  }
}

function selectedValue(select, placeholder) {
  const value = select?.value?.trim() || '';
  return value.toLowerCase() === placeholder.toLowerCase() ? '' : value;
}
const $final_selection = () => {
  const y = selectedValue(yearSelect, 'Year');
  const m = selectedValue(makeSelect, 'Make');
  const md = selectedValue(modelSelect, 'Model');
  const complete = Boolean(y && m && md);
  if (VerifyBtnYMM) VerifyBtnYMM.disabled = !complete;
  if (SearchBtnYMM) {
    SearchBtnYMM.dataset.fatch = complete
      ? `${y}+${m}+${md}`.toLowerCase().replace(/\s+/g, '-') : '';
    SearchBtnYMM.disabled = !complete;
  }
  syncVehicleCartProperties();
};

let ymmRequest = 0;
let productRequest = 0;
async function getYMMData({ year = '', make = '', model = '' } = {}) {
  if (!yearSelect || !makeSelect || !modelSelect) return false;
  const request = ++ymmRequest;
  if (SearchBtnYMM) SearchBtnYMM.disabled = true;
  if (VerifyBtnYMM) VerifyBtnYMM.disabled = true;
  const params = new URLSearchParams({ year, make, model });
  if (window.__st?.p === 'product') params.set('shopify_product_id', window.__st.rid);
  try {
    const response = await fetch(`${baseUrl}?${params}`);
    if (!response.ok) throw new Error(`YMM request failed (${response.status})`);
    const result = await response.json();
    if (request !== ymmRequest) return false;
    if (!result.success || !result.data) throw new Error('Invalid YMM response');
    const populate = (select, label, values, stored) => {
      select.replaceChildren(new Option(label, ''));
      for (const value of values) {
        const text = String(value);
        select.appendChild(new Option(text, text));
      }
      const match = Array.from(select.options).find(option =>
        option.value && option.value.toLowerCase() === String(stored || '').toLowerCase());
      select.value = match?.value || '';
      // An incompatible stored selection must not prevent the list from loading.
      if (stored && !match) {
        const keys = label === 'Year' ? ['selectedYear', 'selectedMake', 'selectedModel']
          : label === 'Make' ? ['selectedMake', 'selectedModel'] : ['selectedModel'];
        keys.forEach(key => sessionStorage.removeItem(key));
      }
    };
    if (!year && Array.isArray(result.data.years)) {
      populate(yearSelect, 'Year', result.data.years, sessionStorage.getItem('selectedYear'));
      makeSelect.replaceChildren(new Option('Make', ''));
      modelSelect.replaceChildren(new Option('Model', ''));
    } else if (year && !make && Array.isArray(result.data.makes)) {
      populate(makeSelect, 'Make', result.data.makes, sessionStorage.getItem('selectedMake'));
      modelSelect.replaceChildren(new Option('Model', ''));
    } else if (year && make && Array.isArray(result.data.models)) {
      populate(modelSelect, 'Model', result.data.models, model || sessionStorage.getItem('selectedModel'));
    }
    $final_selection();
    return true;
  } catch (error) {
    if (request === ymmRequest) console.error('Error fetching YMM data:', error);
    return false;
  }
}

async function selectOption(listItem, optionText) {
  const parent = listItem.closest('.product-info__block-item');
  parent.querySelectorAll('.block-swatch').forEach((el) => {
    el.classList.remove('active-swatch');
  }); 
  const currentSwatchitem = listItem.closest('.block-swatch');
  currentSwatchitem.click();
  if( optionText == 'Choose option' || optionText == 'Select Fitment' ){
    currentSwatchitem.classList.remove('active-swatch');
  }else{
    currentSwatchitem.classList.add('active-swatch');
  }
  const Fitsec = listItem.closest('.fitment-section-wrapp');
  const FitsecLabel = listItem.closest('label');
  const FitsecInput = FitsecLabel.previousElementSibling;
  const Maincont = listItem.closest('.product-info__rowindex');
  const dropdown = listItem.closest('.pro-dropdown-menu');
  const button = dropdown.previousElementSibling;
  button.querySelector('span').textContent = optionText;
  dropdown.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
  listItem.classList.add('selected');
  button.classList.remove('active');
  dropdown.classList.remove('show');

  let ComPrice = listItem.getAttribute('data-cpreice') || '';
  let SelPrice = listItem.getAttribute('data-sprice') || '';
  let variantId = listItem.getAttribute('data-var') || '';
  let Fitvalinput = listItem.getAttribute('data-fitval') || '';
  let Fitvalimg = listItem.getAttribute('data-img-cover') || '';
  let DataConsolecover = listItem.getAttribute('data-consolecover') || '';
  let DataSKU = listItem.getAttribute('data-sku') || '';
  if(Number(SelPrice) > Number(ComPrice)){
    ComPrice = "";
  }
  if(variantId != '' && variantId != 'null'){
    FitsecInput.setAttribute('data-value',variantId);
  }else{
    FitsecInput.setAttribute('data-value',"");
  }
  if(Fitvalinput != '' && Fitvalinput != 'null'){
    FitsecInput.setAttribute('data-fitment-val',Fitvalinput);
  }else{
    FitsecInput.setAttribute('data-fitment-val',"");
  }
  if(Fitvalimg != '' && Fitvalimg != 'null'){
    FitsecInput.setAttribute('data-fitment-img',Fitvalimg);
    FitsecLabel.querySelector('.block-swatch-image').style.setProperty('--swatch-background', `url("${Fitvalimg}")`);
  }else{
    FitsecInput.setAttribute('data-fitment-img',"https://cdn.shopify.com/s/files/1/0698/1609/0787/files/no-image.png?v=1754546526");
    FitsecLabel.querySelector('.block-swatch-image').style.setProperty('--swatch-background', `url("https://cdn.shopify.com/s/files/1/0698/1609/0787/files/no-image.png?v=1754546526")`);
  }
  if(DataConsolecover != '' && DataConsolecover != 'null'){
    FitsecInput.setAttribute('data-consolecover',DataConsolecover);
  }else{
    FitsecInput.setAttribute('data-consolecover',"");
  }
  FitsecInput.setAttribute('data-sku', DataSKU);
  Maincont.setAttribute('data-sku', DataSKU);
  if(DataSKU != '' && DataSKU != 'null'){
    FitsecLabel.querySelector('.text-xs').innerText = `SKU: ${DataSKU}`;
  }
  if(FitsecInput.checked){
    if(Fitvalinput != '' && Fitvalinput != 'null'){
      Maincont.setAttribute('data-selectfit',Fitvalinput);
    }else{
      Maincont.setAttribute('data-selectfit',"");
    }
    if(DataConsolecover != '' && DataConsolecover != 'null'){
      Maincont.setAttribute('data-consolecover',DataConsolecover);
      if(Maincont.nextElementSibling?.classList.contains('product-info__consolecover') && DataConsolecover == "true"){
        Maincont.nextElementSibling?.classList.remove('hide-console-cover');
      }else{
        Maincont.nextElementSibling?.classList.add('hide-console-cover');
      }
    }else{
      Maincont.setAttribute('data-consolecover',"");
      if(Maincont.nextElementSibling?.classList.contains('product-info__consolecover')){
        Maincont.nextElementSibling?.classList.add('hide-console-cover');
      }
    }
    if(Fitvalimg != '' && Fitvalimg != 'null'){
      Maincont.setAttribute('data-fitimage',Fitvalimg);
    }else{
      Maincont.setAttribute('data-fitimage',"https://cdn.shopify.com/s/files/1/0698/1609/0787/files/no-image.png?v=1754546526");
    }
    if(variantId != '' && variantId != 'null'){
      Maincont.setAttribute("data-selectvar",variantId);
    }else{
      Maincont.setAttribute("data-selectvar","");
    }
  }
  updateTotalPrice();
  updateATCButtonState();
  if (currentSwatchitem && currentSwatchitem.classList.contains('active-swatch')) {
    syncSwatchProperties(currentSwatchitem);
  }
}

let container = "";
let ProductmainPrice = "";
let ProductmaincPrice = "";
let ProductVarid = "";

async function renderProductRows(productData) {
  container = document.querySelector('.product-grid-fitmentwrapper');
  const Consoledata = document.querySelector('.product-info__consolecover-js .info-consolecover-data');
  const Consoledatainfo = document.querySelector('.product-info__consolecover-js .info-consolecover-data-info');
  if (!container) return;
  ProductmainPrice = Number(document.querySelector('buy-buttons .button, .buy-buttons button')?.getAttribute('data-price')) || 0;
  ProductmaincPrice = Number(document.querySelector('buy-buttons .button, .buy-buttons button')?.getAttribute('data-cprice')) || 0;
  ProductVarid = document.querySelector('.product-grid-fitmentwrapper').getAttribute('data-id');
  let ConsolePrice  = "";
  let ConsoleCPrice  = "";
  let ConsoleId  = "";
  let Consoleimg  = "";
  let Consoleinfocont  = "";
  container.innerHTML = '';
  if(Consoledata){
    ConsolePrice  = Consoledata.getAttribute('data-varprice');
    ConsoleCPrice  = Consoledata.getAttribute('data-varcprice');
    ConsoleId  = Consoledata.getAttribute('data-varid');
    Consoleimg  = Consoledata.getAttribute('data-image');
    if(!Consoleimg || Consoleimg.trim() === ''){
      Consoleimg = "https://cdn.shopify.com/s/files/1/0698/1609/0787/files/no-image.png?v=1754546526";
    }
  }
  if(Consoledatainfo){
    Consoleinfocont = Consoledatainfo.innerHTML;
  }

  productData.forEach((rowData, rowIndex) => {
    const position = rowData.position;
    const positionHandle = `position_${position.toLowerCase().replace(/\s+/g, '_')}`;
    let inputHTML = '';

    if(floor_mats_active){
      const floorVariants = window.GPOConfigs?.product?.variants || []
      if(floorVariants.length > 0) {
        const lowerPosition = position.toLowerCase()
        const searchTerm = lowerPosition.includes('cargo') ? 'cargo' : lowerPosition.includes('front') ? 'front' : lowerPosition.includes('2 row') ? '2 row' : '3 row'
        const selectedVariant = floorVariants.find(fv => fv.name.toLowerCase().includes(searchTerm))

        if(selectedVariant) {
          ProductmainPrice = Number(selectedVariant.price)
          ProductmaincPrice = Number(selectedVariant['compare_at_price'] || 0)
          ProductVarid = selectedVariant.id
        }
      }
    }

    rowData.styles?.forEach((style, styleIndex) => {
      const inputId   = `${positionHandle}_style_${styleIndex}_${rowIndex}`;
      const nameAttr  = `${positionHandle}`;
      const GridStyleName   = style.style_name;
      const primaryFit = style.fitments?.[0];
      const primaryProd  = primaryFit?.products?.[0] || {};
      let baseImage = primaryProd.product_img_url || '';
      let baseSKU = primaryProd.sku || '';
      const baseConsolecover = primaryProd.console_cover || '';
      const baseFitmentval = primaryFit?.fitment_title || '';
      const basePrice  = primaryProd.price  || 0;
      if(!baseImage || baseImage.trim() === ''){
          baseImage = "https://cdn.shopify.com/s/files/1/0698/1609/0787/files/no-image.png?v=1754546526";
      }
      let dropdownTitle = 'Select fitment';
      let dropCount = style.fitments?.length || 0;
      if (!dropCount) return;
      let dropdownOptions = null;
      if(dropCount == 1 && (style.fitments[0].fitment_title === null || style.fitments[0].fitment_title === "")){
        dropdownOptions = null;
      }else{
        if(dropCount == 1){
          dropdownOptions = style.fitments.map((fitment, fitmentIndex) => {
            const prod = fitment.products?.[0] || {};
            const isSelected = fitmentIndex === 0 ? 'selected' : '';
            if (fitmentIndex === 0) dropdownTitle = fitment.fitment_title;

            return `
              <li class="${isSelected}"
                  data-consolecover="${escapeHTML(prod.console_cover)}" 
                  data-img-cover="${escapeHTML(prod.product_img_url)}" data-sku="${escapeHTML(prod.sku)}" data-fitval="${escapeHTML(fitment.fitment_title)}">
                ${escapeHTML(fitment.fitment_title)}
              </li>
            `;
          }).join('');
        }else{
          dropdownTitle = 'Select Fitment';
          dropdownOptions = `
            <li class="selected choose-option" 
                    data-consolecover="" 
                    data-img-cover=""
                    data-sku=""
                    data-fitval="">
              Choose option
            </li>
            ${style.fitments.map((fitment) => {
              const prod = fitment.products?.[0] || {};

              return `
                <li
                    data-consolecover="${escapeHTML(prod.console_cover)}" 
                    data-img-cover="${escapeHTML(prod.product_img_url)}"
                    data-sku="${escapeHTML(prod.sku)}"
                    data-fitval="${escapeHTML(fitment.fitment_title)}">
                  ${escapeHTML(fitment.fitment_title)}
                </li>
              `;
            }).join('')}
          `;
        }
      }
      inputHTML += `
        <input
          class="sr-only"
          type="radio"
          id="${inputId}"
          name="${nameAttr}"
          value="${escapeHTML(GridStyleName)}"
          data-fitment-img="${dropCount == 1 ? escapeHTML(baseImage) : ''}"
          data-fitment-val="${dropCount == 1 ? escapeHTML(baseFitmentval) : ''}"
          data-sku="${dropCount == 1 ? escapeHTML(baseSKU) : ''}"
          data-consolecover="${dropCount == 1 ? escapeHTML(baseConsolecover) : ''}"
          data-cprice="${ProductmaincPrice}"
          data-sprice="${ProductmainPrice}">
        <label class="block-swatch" for="${inputId}">
          <span class="checked-mark">
            <svg class="active-check" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
              <path d="M16.797 30.9977C14.8607 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1633 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83833 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8607 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83833 29.6914 11.5413C30.4267 13.2444 30.7944 15.064 30.7944 17.0003C30.7944 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1633 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="white"></path>
              <path d="M14.8373 23.4391L24.7055 13.571L22.7458 11.6113L14.8373 19.5199L10.8481 15.5306L8.88843 17.4902L14.8373 23.4391ZM16.797 30.9977C14.8606 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1632 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83832 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8606 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83832 29.6914 11.5413C30.4267 13.2444 30.7943 15.064 30.7943 17.0003C30.7943 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1632 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="#008535"></path>
            </svg>
            <svg class="check-in-check" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
              <path d="M16.797 30.9977C14.8607 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1633 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83833 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8607 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83833 29.6914 11.5413C30.4267 13.2444 30.7944 15.064 30.7944 17.0003C30.7944 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1633 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="white"></path>
              <path d="M16.797 30.9977C14.8606 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1632 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83832 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8606 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83832 29.6914 11.5413C30.4267 13.2444 30.7943 15.064 30.7943 17.0003C30.7943 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1632 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="#B4A000"></path>
              <rect x="15.5" y="9" width="2.6" height="11" rx="1.3" fill="white"/>
              <circle cx="16.8" cy="23.5" r="1.6" fill="white"/>
            </svg>
          </span>
          <div class="text-xs">SKU: ${escapeHTML(baseSKU)}</div>
          <span
            class="block-swatch-image"
            style="--swatch-background: url(${escapeHTML(baseImage)});">
          </span>
          <div class="fitment-section-wrapp">
            <div class="fitment-section v-stack gap-2" style="${dropdownOptions === null ? 'display:none;' : ''}">
              <!--<p>Select fitment</p>-->
              <div class="dropdown-container">
                <button type="button" class="dropdown-button fit-dropdown-button">
                  <span class="dropdown-title">${escapeHTML(dropdownTitle)}</span>
                  <div class="dropdown-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
                      <path d="M14.6667 9.36914L10.8473 13.1886L7.02786 9.36914" stroke="white" stroke-width="1.375"></path>
                    </svg>
                  </div>
                </button>
                <div class="pro-dropdown-menu">
                  <ul>
                    ${dropdownOptions || ''}
                  </ul>
                </div>
              </div>
            </div>
            <price-list class="price-list sm:text-lg">
              <compare-at-price class="text-subdued line-through">
                <span class="sr-only">Regular price</span>
                <span class="pro">
                  ${
                    ProductmaincPrice > ProductmainPrice
                      ? window.$money_format(ProductmaincPrice, window.$shop_money_format)
                      : ''
                  }
                </span>
              </compare-at-price>
              <sale-price class="text-on-sale">
                <span class="sr-only">Sale price</span>
                <span class="prs">${ProductmainPrice ? window.$money_format(ProductmainPrice, window.$shop_money_format) : ''}</span>
              </sale-price>
            </price-list>
          </div>
        </label>
      `;
    });

    if (!inputHTML) {
      console.warn(`No styles found for ${escapeHTML(position)}`);
    }

    
    const block = `
      <div
        class="product-grid-wrap product-info__block-item product-info__rowindex atc-product-variant"
        data-fatch-row="${positionHandle}"
        data-position="${escapeHTML(position)}"
        data-row-index="${rowIndex + 1}"
        data-block-id="custom_variant_picker_${rowIndex + 1}"
        data-block-type="custom-variant-picker-${rowIndex + 1}"
        data-price="${ProductmainPrice}"
        data-cprice="${ProductmaincPrice}"
        data-addvar="${ProductVarid}"
        data-selectvar="" data-selectfit="" data-fitimage="" data-selectstyle="" data-consolecover="" data-sku="">
        
        <div class="variant-picker__option-info info-removed-head">
          <div class="h-stack gap-2">
            <legend class="text-subdued">Fitment Option:</legend>
            <span>${escapeHTML(position)}</span>
          </div>
          <button type="button" class="remove-btn remove-row-btn">
            REMOVE ${position.toUpperCase()}
          </button>
        </div>
        
        <div class="variant-picker__option-info info-added-head">
          <div class="h-stack gap-2">
            <span>I don't want a ${position.toLowerCase()}.</span>
          </div>
          <button type="button" class="add-row add-row-btn" data-row="${rowIndex + 1}">
            ADD ${position.toUpperCase()}
          </button>
        </div>
        
        <fieldset class="fitment-picker__option">
          <div class="variant-picker__option-values position-select-row wrap gap-2">
            ${inputHTML}
          </div>
        </fieldset>
      </div>
      <div class="product-grid-wrap product-info__block-item product-info__consolecover atc-product-variant hide-console-cover" data-block-id="custom_variant_picker_${rowIndex + 1}" data-block-type="custom-variant-picker-${rowIndex + 1}" data-price="0" data-cprice="0">
        <div class="variant-picker__option_trigger">      
          <input class="checkbox console-selected-data-check" type="checkbox" id="console_cover_${rowIndex + 1}_trigger_box">
          <label class="block-swatch-triger" for="console_cover_${rowIndex + 1}_trigger_box">
            <div class="label-wrapp-header"><div class="label-wrapp-infocont"><p>Add console cover</p> <div class="bold console-price">${window.$money_format(ConsolePrice , window.$shop_money_format)}</div></div><div class="label-infocont-inn">${Consoleinfocont}</div></div>
            <span class="block-swatch__color" style="--swatch-background: url(${Consoleimg});"></span>
          </label>
        </div>
        <fieldset class="variant-picker__option">
          <div class="variant-picker__option-info">
            <div class="h-stack gap-2">
              <legend class="text-subdued">Console cover:</legend>
              <span>None</span>
            </div>
          </div>
      
          <div class="variant-picker__option-values console-select-row wrap gap-2">
            <input class="sr-only" type="radio" id="console_cover_${rowIndex + 1}_none" value="None" data-price-select="0" data-price-cselect="0" name="console_cover_${rowIndex + 1}" checked="checked">
            <label class="block-swatch console-card" for="console_cover_${rowIndex + 1}_none">
              <span class="checked-mark">
                <svg class="active-check" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                  <path d="M16.797 30.9977C14.8607 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1633 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83833 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8607 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83833 29.6914 11.5413C30.4267 13.2444 30.7944 15.064 30.7944 17.0003C30.7944 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1633 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="white"></path>
                  <path d="M14.8373 23.4391L24.7055 13.571L22.7458 11.6113L14.8373 19.5199L10.8481 15.5306L8.88843 17.4902L14.8373 23.4391ZM16.797 30.9977C14.8606 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1632 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83832 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8606 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83832 29.6914 11.5413C30.4267 13.2444 30.7943 15.064 30.7943 17.0003C30.7943 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1632 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="#008535"></path>
                </svg>
                <svg class="check-in-check" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                  <path d="M16.797 30.9977C14.8607 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1633 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83833 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8607 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83833 29.6914 11.5413C30.4267 13.2444 30.7944 15.064 30.7944 17.0003C30.7944 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1633 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="white"></path>
                  <path d="M16.797 30.9977C14.8606 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1632 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83832 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8606 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83832 29.6914 11.5413C30.4267 13.2444 30.7943 15.064 30.7943 17.0003C30.7943 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1632 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="#B4A000"></path>
                  <rect x="15.5" y="9" width="2.6" height="11" rx="1.3" fill="white"/>
                  <circle cx="16.8" cy="23.5" r="1.6" fill="white"/>
                </svg>
              </span>
              <span class="block-swatch__color" style="--swatch-background: url(https://cdn.shopify.com/s/files/1/0698/1609/0787/files/image_15.png?v=1751611545);"></span>
              <p>None</p>
            </label>
            <input class="sr-only console-selected-data-iput" type="radio" id="console_cover_${rowIndex + 1}_none_console_box" value="Yes" data-price-select="${ConsolePrice}" data-price-cselect="${ConsoleCPrice}" name="console_cover_${rowIndex + 1}">
            <label class="block-swatch console-card console-selected-data-label" for="console_cover_${rowIndex + 1}_none_console_box">
              <span class="checked-mark ">
                <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                  <path d="M16.797 30.9977C14.8607 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1633 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83833 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8607 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83833 29.6914 11.5413C30.4267 13.2444 30.7944 15.064 30.7944 17.0003C30.7944 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1633 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="white"></path>
                  <path d="M14.8373 23.4391L24.7055 13.571L22.7458 11.6113L14.8373 19.5199L10.8481 15.5306L8.88843 17.4902L14.8373 23.4391ZM16.797 30.9977C14.8606 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1632 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83832 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8606 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83832 29.6914 11.5413C30.4267 13.2444 30.7943 15.064 30.7943 17.0003C30.7943 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1632 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="#008535"></path>
                </svg>
              </span>
              <span class="block-swatch__color" style="--swatch-background: url(${Consoleimg});"></span>
              <p>Add console cover</p>
              <div class="text-xs bold console-price">${window.$money_format(ConsolePrice , window.$shop_money_format)}</div>
            </label>
          </div>
        </fieldset>
      </div>
    `;
    container.insertAdjacentHTML('beforeend', block);
  });
  attachRowHandlers();
}
async function renderProductunRows(productData){
  container = document.querySelector('.product-grid-fitmentwrapper');
  if (!container) return;
  ProductmainPrice = Number(document.querySelector('buy-buttons .button, .buy-buttons button')?.getAttribute('data-price')) || 0;
  ProductmaincPrice = Number(document.querySelector('buy-buttons .button, .buy-buttons button')?.getAttribute('data-cprice')) || 0;
  ProductVarid = document.querySelector('.product-grid-fitmentwrapper').getAttribute('data-id');
  container.innerHTML = '';
  const position = "Select Option";
  const positionHandle = `position_${position.toLowerCase().replace(/\s+/g, '_')}`;
  const inputId   = `${positionHandle}_style`;
  const nameAttr  = `${positionHandle}`;
  let inputHTML = '';

  productData.forEach((rowData, rowIndex) => {
    const GridStyleName = rowData.style_name;
    let baseImage = rowData.products?.[0]?.product_img_url || '';
    let baseSKU = rowData.products?.[0]?.sku || '';
    const baseConsolecover = '';
    const baseFitmentval = '';
    if(!baseImage || baseImage.trim() === ''){
        baseImage = "https://cdn.shopify.com/s/files/1/0698/1609/0787/files/no-image.png?v=1754546526";
    }
    if(floor_mats_active){
    }

    inputHTML += `
      <input
        class="sr-only"
        type="radio"
        id='${inputId}_${rowIndex}'
        name='${nameAttr}'
        value='${escapeHTML(GridStyleName)}'
        data-fitment-img='${escapeHTML(baseImage)}'
        data-sku="${escapeHTML(baseSKU)}"
        data-fitment-val='${escapeHTML(baseFitmentval)}'
        data-consolecover='${escapeHTML(baseConsolecover)}'
        data-cprice='${ProductmaincPrice}'
        data-sprice='${ProductmainPrice}'>
      <label class="block-swatch" for="${inputId}_${rowIndex}">
        <span class="checked-mark">
          <svg class="active-check" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
            <path d="M16.797 30.9977C14.8607 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1633 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83833 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8607 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83833 29.6914 11.5413C30.4267 13.2444 30.7944 15.064 30.7944 17.0003C30.7944 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1633 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="white"></path>
            <path d="M14.8373 23.4391L24.7055 13.571L22.7458 11.6113L14.8373 19.5199L10.8481 15.5306L8.88843 17.4902L14.8373 23.4391ZM16.797 30.9977C14.8606 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1632 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83832 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8606 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83832 29.6914 11.5413C30.4267 13.2444 30.7943 15.064 30.7943 17.0003C30.7943 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1632 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="#008535"></path>
          </svg>
          <svg class="check-in-check" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
            <path d="M16.797 30.9977C14.8607 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1633 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83833 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8607 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83833 29.6914 11.5413C30.4267 13.2444 30.7944 15.064 30.7944 17.0003C30.7944 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1633 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="white"></path>
            <path d="M16.797 30.9977C14.8606 30.9977 13.041 30.6301 11.338 29.8947C9.63496 29.1603 8.15356 28.1632 6.8938 26.9035C5.63403 25.6437 4.63695 24.1623 3.90256 22.4593C3.16723 20.7563 2.79956 18.9366 2.79956 17.0003C2.79956 15.064 3.16723 13.2444 3.90256 11.5413C4.63695 9.83832 5.63403 8.35693 6.8938 7.09717C8.15356 5.8374 9.63496 4.83985 11.338 4.10452C13.041 3.37013 14.8606 3.00293 16.797 3.00293C18.7333 3.00293 20.5529 3.37013 22.2559 4.10452C23.959 4.83985 25.4403 5.8374 26.7001 7.09717C27.9599 8.35693 28.957 9.83832 29.6914 11.5413C30.4267 13.2444 30.7943 15.064 30.7943 17.0003C30.7943 18.9366 30.4267 20.7563 29.6914 22.4593C28.957 24.1623 27.9599 25.6437 26.7001 26.9035C25.4403 28.1632 23.959 29.1603 22.2559 29.8947C20.5529 30.6301 18.7333 30.9977 16.797 30.9977Z" fill="#B4A000"></path>
            <rect x="15.5" y="9" width="2.6" height="11" rx="1.3" fill="white"/>
            <circle cx="16.8" cy="23.5" r="1.6" fill="white"/>
          </svg>
        </span>
        <div class="text-xs">SKU: ${escapeHTML(baseSKU)}</div>
        <span
          class="block-swatch-image"
          style="--swatch-background: url(${escapeHTML(baseImage)});">
        </span>
        <div class="fitment-section-wrapp">
          <div class="fitment-style-content">
            <max-height class="max-height collection-banner--description" data-max="50" style="--max-height: 50px;">
              <div class="max-height--inner">
                <div class="max-height--inner-content rte">${escapeHTML(rowData.style_name)}</div>
              </div>
              <button type="button" class="max-height--toggle"><span class="text-button text-button--read-more">Read more</span><span class="text-button text-button--read-less">Read less</span></button>
            </max-height>
          </div>
          <price-list class="price-list sm:text-lg">
            <compare-at-price class="text-subdued line-through">
              <span class="sr-only">Regular price</span>
              <span class="pro">
                ${ ProductmaincPrice > ProductmainPrice ? window.$money_format(ProductmaincPrice, window.$shop_money_format) : '' }
              </span>
            </compare-at-price>
            <sale-price class="text-on-sale">
              <span class="sr-only">Sale price</span>
              <span class="prs">${ProductmainPrice ? window.$money_format(ProductmainPrice, window.$shop_money_format) : ''}</span>
            </sale-price>
          </price-list>
        </div>
      </label>
    `;

    if (!inputHTML) {
      console.warn(`No styles found for ${escapeHTML(position)}`);
    }
  });
  const block = `
    <div
      class="product-grid-wrap product-info__block-item product-info__rowindex atc-product-variant"
      data-fatch-row="${positionHandle}"
      data-position=""
      data-row-index="${escapeHTML(position)}"
      data-block-id="custom_variant_picker_1"
      data-block-type="custom-variant-picker-1"
      data-price="${ProductmainPrice}"
      data-cprice="${ProductmaincPrice}"
      data-addvar="${ProductVarid}"
      data-selectvar="" data-selectfit="" data-fitimage="" data-selectstyle="" data-consolecover="" data-sku="">
      
      <div class="variant-picker__option-info info-removed-head">
        <div class="h-stack gap-2">
          <legend class="text-subdued">Select Option:</legend>
        </div>
      </div>
      
      <fieldset class="fitment-picker__option">
        <div class="variant-picker__option-values position-select-row wrap gap-2">
          ${inputHTML}
        </div>
      </fieldset>
    </div>
  `;
  container.insertAdjacentHTML('beforeend', block);
  attachRowHandlers();
}

async function getProductYMMData({ year = "", make = "", model = "", shopify_product_id = ""} = {}) {
  const request = ++productRequest;
  if (!document.querySelector('.product-grid-fitmentwrapper')) return false;
  fitmentNeedsVerification = true;
  updateATCButtonState();
  year = year || "";
  make = make || "";
  model = model || "";
  shopify_product_id = shopify_product_id || "";
  const queryParams = new URLSearchParams({ year, make, model, shopify_product_id }).toString();
  const url = `${probaseUrl}?${queryParams}`;
  
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });
    if (!response.ok) throw new Error(`Product request failed (${response.status})`);
    const result = await response.json();
    if (request !== productRequest) return false;
    if (!result.success || !result.data) throw new Error('Invalid product response');
    if (result.success && result.data) {
      document.querySelector('.product-grid-fitmentwrapper-nodata')?.classList.add('hide-nodata-error');
      const embroidery = document.querySelector('[data-block-id=custom_embroidery]');
      if (embroidery) embroidery.style.display = 'block';
      fitmentNeedsVerification = false;
      const Structured = result.data.structured;
      const UnStructured = result.data.unstructured;
      
      if(Array.isArray(Structured) && Structured.length !== 0){
        renderProductRows(Structured);
        updateATCButtonState();
        selectSoloItem(Structured);
      } else if(Array.isArray(UnStructured) && UnStructured.length !== 0){
        renderProductunRows(UnStructured);
        updateATCButtonState();
      } else{
        console.error("No data found.");
        const element = document.querySelector(".product-grid-fitmentwrapper-nodata");
        document.querySelector('.product-grid-fitmentwrapper').innerHTML = "";
        element?.classList.remove("hide-nodata-error");
        const embElement = document.querySelector('[data-block-id="custom_embroidery"]')
        if(embElement) embElement.style.display = 'none'
        
        updateATCButtonState();
      }
    }
    if (ClearBtnYMM) {
      ClearBtnYMM.style.display = 'flex';
    }
    syncVehicleCartProperties();
    return true;
  } catch (error) {
    console.error("Error fetching YMM data:", error);
  }
}

let year = "";
let make = "";
let model = "";
let shopify_product_id = "";
if(document.querySelector('.product-info__gettitle')){
  shopify_product_id = document.querySelector('.product-info__gettitle').getAttribute('data-pid');
}
async function restoreSessionSelections() {
  const storedYear = sessionStorage.getItem('selectedYear');
  const storedMake = sessionStorage.getItem('selectedMake');
  const storedModel = sessionStorage.getItem('selectedModel');

  if(document.querySelector('.yearselect-coll')){
    document.querySelector('.yearselect-coll').innerText = storedYear;
  }
  if(document.querySelector('.makeselect-coll')){
    document.querySelector('.makeselect-coll').innerText = storedMake;
  }
  if(document.querySelector('.modelselect-coll')){
    document.querySelector('.modelselect-coll').innerText = storedModel;
  }
  if(document.querySelector('.ymm-coll-bredcrumbs')){
    if(storedYear != null || storedMake != null || storedModel != null){
      document.querySelector('.ymm-coll-bredcrumbs').style.display = 'block';
    }else{
      document.querySelector('.ymm-coll-bredcrumbs').style.display = 'none';
    }
  }
  if(document.querySelector('.ymm-custom-element-products')){
    if(storedYear != null && storedMake != null && storedModel != null) {
      const Carname = storedYear + " " + storedMake + " " + storedModel;
      if(document.querySelector('.vehicle-selected-edite span')){
        document.querySelector('.vehicle-selected-edite span').innerText = Carname;
      }
      if(document.querySelector('.ymm-custom-element-products .search-container')){
        document.querySelector('.ymm-custom-element-products .search-container').classList.add('hide-data-selection');
      }
      if(document.querySelector('.ymm-custom-element-products .product-info__block-item')){
        document.querySelector('.ymm-custom-element-products .product-info__block-item').classList.add('activedata-selection');
      }
      
    }
  }
  
  if (!await getYMMData()) return;
  year = selectedValue(yearSelect, 'Year');
  if (year && makeSelect && modelSelect) {
    if (!await getYMMData({ year })) return;
    makeSelect.disabled = false;
    makeSelect.parentElement?.classList.remove('disabled');
    make = selectedValue(makeSelect, 'Make');
    if (make) {
      if (!await getYMMData({ year, make })) return;
      modelSelect.disabled = false;
      modelSelect.parentElement?.classList.remove('disabled');
      model = selectedValue(modelSelect, 'Model');
    }
  }
  $final_selection();
  const title = document.querySelector('.product-info__gettitle');
  if (title) {
    shopify_product_id = title.getAttribute('data-pid');
    await getProductYMMData({ year, make, model, shopify_product_id });
  }
  syncVehicleCartProperties();
}



function updateTotalPrice() {
  let variantTotal = 0;
  let variantcurTotal = 0;

  document.querySelectorAll('.product-info__rowindex:not(.removed-row-data)').forEach(el => {
    const checkedInput = el.querySelector('.variant-picker__option-values input:checked');
    if (checkedInput) {
      const price = parseFloat(el.getAttribute('data-price')) || 0;
      const cprice = parseFloat(el.getAttribute('data-cprice')) || 0;

      if (!isNaN(price) && price > 0) {
        variantTotal += price;
      }
      if (!isNaN(cprice) && cprice > 0) {
        variantcurTotal += cprice;
      }
    }
  });

  const buyButtons = document.querySelector('.product-info__block-item .buy-buttons button');
  if (!buyButtons) return;
  const btnbasePrice = parseFloat(buyButtons?.getAttribute('data-price')) || 0;
  const btnbasecPrice = parseFloat(buyButtons?.getAttribute('data-cprice')) || 0;
  if (variantTotal === 0) {
    variantTotal = btnbasePrice;
    variantcurTotal = btnbasecPrice;
  }
  const total = variantTotal;
  const Curtotal = variantcurTotal;
  const QTYdata = Math.max(1, Number(document.querySelector('.product-info__quantity-selector .quantity-selector__input')?.value) || 1);
  const Finaltotal = total * QTYdata;
  const Finalcurtotal = Curtotal * QTYdata;
  buyButtons.dataset.totalPrice = Finaltotal;
  buyButtons.dataset.totalcurrPrice = Finalcurtotal;
  if(!window.$money_format) return;
  const salePriceEl = buyButtons.querySelector('sale-price');
  const currPriceEl = buyButtons.querySelector('compare-at-price');
  if (!salePriceEl) return;
  if (salePriceEl) {
    salePriceEl.innerHTML = `<span class="sr-only">Sale price</span>`+window.$money_format(Finaltotal, window.$shop_money_format);
  }
  if (!currPriceEl) return;
  if (currPriceEl) {
    currPriceEl.innerHTML = `<span class="sr-only">Regular price</span>`+window.$money_format(Finalcurtotal, window.$shop_money_format);
  }
}

async function addRow(button) {
  const container = button.closest('.product-grid-wrap');
  if (!container) return;
  container.classList.remove('removed-row-data');
  if(container.getAttribute('data-consolecover') == "true"){
    container.nextElementSibling?.classList.remove('hide-console-cover');
  }
  updateTotalPrice();
  updateATCButtonState();
}
async function removeRow(button) {
  const container = button.closest('.product-grid-wrap');
  if (!container) return;
  container.classList.add('removed-row-data');
  if(container.getAttribute('data-consolecover')){
    container.nextElementSibling?.classList.add('hide-console-cover');
  }
  updateTotalPrice();
  updateATCButtonState();
}

function attachRowHandlers() {
  document.querySelectorAll('.add-row-btn').forEach(button => {
    button.removeEventListener('click', handleAddRow); // Prevent duplicate bindings
    button.addEventListener('click', handleAddRow);
  });

  document.querySelectorAll('.remove-row-btn').forEach(button => {
    button.removeEventListener('click', handleRemoveRow);
    button.addEventListener('click', handleRemoveRow);
  });
}

async function handleAddRow(event) {
  await addRow(event.currentTarget);
}

async function handleRemoveRow(event) {
  await removeRow(event.currentTarget);
}

function clearButtonErrorMsg() {
  const ErrorMsg = document.querySelector('.product-info__errormsg')
  if(ErrorMsg) ErrorMsg.classList.add('hide-errormsg')

  document.querySelectorAll('.atc-error-message').forEach(message => message.remove());
  const submitButtons = document.querySelectorAll('.shopify-product-form button[type="submit"]')
  submitButtons.forEach((submitButton) => {
    submitButton.setAttribute("aria-busy", "false");
  });
}

onReady(async function () {
  yearSelect = document.getElementById('yearSelect');
  makeSelect = document.getElementById('makeSelect');
  modelSelect = document.getElementById('modelSelect');
  SearchBtnYMM = document.getElementById('ymm-serch-btn');
  VerifyBtnYMM = document.getElementById('ymm-verify-btn');
  ClearBtnYMM = document.getElementById('ymm-clear-btn');
  floor_mats_active = Boolean(document.querySelector('.hide_variant_picker_cls'));
  const YMMModel = document.querySelector('.vehicle-select-wrapper');
  if (!YMMModel || !yearSelect || !makeSelect || !modelSelect) return;

  if(yearSelect){
    yearSelect.addEventListener('change', async function () {
      clearButtonErrorMsg()
      year = selectedValue(this, 'Year');
      make = ''; model = '';
      ++ymmRequest; ++productRequest;
      fitmentNeedsVerification = Boolean(document.querySelector('.product-grid-fitmentwrapper'));
      updateATCButtonState();
  
      sessionStorage.setItem('selectedYear', year);
      sessionStorage.removeItem('selectedMake');
      sessionStorage.removeItem('selectedModel');
      $final_selection();
  
      makeSelect.innerHTML = '<option value="" selected>Make</option>';
      modelSelect.innerHTML = '<option value="" selected>Model</option>';
      modelSelect.disabled = true;
      modelSelect.parentElement.classList.add('disabled');
  
      if (year !== '') {
        const loaded = await getYMMData({ year });
        if (!loaded) return;
        makeSelect.disabled = false;
        makeSelect.parentElement.classList.remove('disabled');
      } else {
        makeSelect.disabled = true;
        makeSelect.parentElement.classList.add('disabled');
      }
    });
  }
  if(makeSelect){
    makeSelect.addEventListener('change', async function () {
      clearButtonErrorMsg()
      
      make = selectedValue(this, 'Make');
      model = '';
      ++ymmRequest; ++productRequest;
      fitmentNeedsVerification = Boolean(document.querySelector('.product-grid-fitmentwrapper'));
      updateATCButtonState();
  
      sessionStorage.setItem('selectedMake', make);
      sessionStorage.removeItem('selectedModel');
      $final_selection();
  
      modelSelect.innerHTML = '<option value="" selected>Model</option>';
  
      if (make !== '') {
        modelSelect.disabled = true;
        const loaded = await getYMMData({ year, make });
        if (!loaded) return;
        modelSelect.disabled = false;
        modelSelect.parentElement.classList.remove('disabled');
      } else {
        modelSelect.disabled = true;
        modelSelect.parentElement.classList.add('disabled');
      }
    });
  }
  if(modelSelect){
    modelSelect.addEventListener('change',async function () {
      clearButtonErrorMsg()

      model = selectedValue(this, 'Model');
      ++ymmRequest; ++productRequest;
      fitmentNeedsVerification = Boolean(document.querySelector('.product-grid-fitmentwrapper'));
      updateATCButtonState();
      if (model !== '') {
        sessionStorage.setItem('selectedModel', model);
        $final_selection();
      } else {
        sessionStorage.removeItem('selectedModel');
      $final_selection();
      }
    });
  }

  var productId = window?.meta?.product?.id;
  if(productId == 8872851275939){
    sessionStorage.removeItem('selectedYear');
    sessionStorage.removeItem('selectedMake');
    sessionStorage.removeItem('selectedModel');
      $final_selection();
  }
  restoreSessionSelections();
  attachRowHandlers();
  const pathUrl = window.location.pathname;
  const CollectionhasTag = /^\/collections\/[^\/]+\/.+\+.+$/.test(pathUrl);
  if (CollectionhasTag) {
    setTimeout(() => {
      const targetSection = document.querySelector('.collection');
      if (targetSection) {
        const offset = targetSection.getBoundingClientRect().top + window.pageYOffset - 120;
        window.scrollTo({ top: offset, behavior: 'smooth' });
      }
    }, 500);
  }

  if(SearchBtnYMM){
    SearchBtnYMM.addEventListener('click',async function () {
      if (SearchBtnYMM.disabled || !SearchBtnYMM.dataset.fatch) return;
      window.location.href = SearchBtnYMM.getAttribute("data-surl")+'/'+SearchBtnYMM.getAttribute("data-fatch");
    });
  }

  if(VerifyBtnYMM){
    VerifyBtnYMM.addEventListener('click',async function () {
      clearButtonErrorMsg()
      if (VerifyBtnYMM.disabled) return;
      year = selectedValue(yearSelect, 'Year');
      make = selectedValue(makeSelect, 'Make');
      model = selectedValue(modelSelect, 'Model');
     shopify_product_id = document.querySelector('.product-info__gettitle')?.getAttribute('data-pid') || '';
     const loaded = await getProductYMMData({ year, make, model, shopify_product_id});
     if (!loaded) return;
     updateTotalPrice();
     if(document.querySelector('.ymm-custom-element-products')){
        if(year && make && model) {
          const Carname = year + " " + make + " " + model;
          if(document.querySelector('.vehicle-selected-edite span')){
            document.querySelector('.vehicle-selected-edite span').innerText = Carname;
          }
          if(document.querySelector('.ymm-custom-element-products .search-container')){
            document.querySelector('.ymm-custom-element-products .search-container').classList.add('hide-data-selection');
          }
          if(document.querySelector('.ymm-custom-element-products .product-info__block-item')){
            document.querySelector('.ymm-custom-element-products .product-info__block-item').classList.add('activedata-selection');
          }
        }
      }
    });
  }
  
  if(ClearBtnYMM){
    ClearBtnYMM.addEventListener('click',async function () {
      if(document.querySelector('.shopify-product-form .buy-buttons button[type="submit"]')){
        document.querySelector('.shopify-product-form .buy-buttons button[type="submit"]').classList.add('disabled');
      }
      if(document.querySelector('.product-grid-fitmentwrapper-nodata')){
        document.querySelector('.product-grid-fitmentwrapper-nodata').classList.add('hide-nodata-error')
      }
      const embElement = document.querySelector('[data-block-id="custom_embroidery"]')
      if(embElement) embElement.style.display = 'block'
      ++ymmRequest; ++productRequest;
      year = ''; make = ''; model = '';
      sessionStorage.removeItem('selectedYear');
      sessionStorage.removeItem('selectedMake');
      sessionStorage.removeItem('selectedModel');
      $final_selection();
      makeSelect.disabled = true;
      makeSelect.parentElement.classList.add('disabled');
      modelSelect.disabled = true;
      modelSelect.parentElement.classList.add('disabled');
      

      const fitmentWrapper = document.querySelector('.product-grid-fitmentwrapper');
      if(fitmentWrapper) fitmentWrapper.innerHTML = "";
      
      if(SearchBtnYMM){
        SearchBtnYMM.disabled = true;
      }
      if(VerifyBtnYMM){
        VerifyBtnYMM.disabled = true;
      }
      await getYMMData();
      if(document.querySelector('.ymm-custom-element-products .search-container')){
        document.querySelector('.ymm-custom-element-products .search-container').classList.remove('hide-data-selection');
      }
      if(document.querySelector('.ymm-custom-element-products .product-info__block-item')){
        document.querySelector('.ymm-custom-element-products .product-info__block-item').classList.remove('activedata-selection');
      }
    });
  }
});
document.addEventListener('change', async function (event) {
  const optionTrigger = event.target.closest('.variant-picker__option_trigger');
  if (!optionTrigger) return;

  const checkEl = optionTrigger.querySelector('.console-selected-data-check');
  if (!checkEl) return;

  const optionValues = optionTrigger.nextElementSibling?.querySelector('.variant-picker__option-values');
  if (!optionValues) return;

  if (checkEl.checked) {
    const yesInputLabel = optionValues.querySelector('input[value="Yes"]')?.nextElementSibling;
    if (yesInputLabel) yesInputLabel.click();
  } else {
    const noneInputLabel = optionValues.querySelector('input[value="None"]')?.nextElementSibling;
    if (noneInputLabel) noneInputLabel.click();
  }
});
document.addEventListener('click', function(event) {
 if (!event.target.closest('.dropdown-container')) {
   document.querySelectorAll('.fit-dropdown-button').forEach(btn => {
     btn.classList.remove('active');
     btn.nextElementSibling?.classList.remove('show');
   });
 }
});
document.addEventListener('change',async function (event) {
  if(floor_mats_active && event.target.closest('.position-select-row') && event.target.matches('input[type=checkbox], input[type=radio]')){
    const currentRow = event.target.closest('.product-info__rowindex');
    if (!currentRow) return;
    const currentFitment = currentRow.getAttribute('data-position');

    const currentInput = event.target;
    if (!currentInput.matches('input[type="checkbox"], input[type="radio"]')) return;

    const allRows = document.querySelectorAll('.product-info__rowindex');

    if(currentFitment !== 'Cargo mat'){
      allRows.forEach(row => {
        const inputcurrentFitment = row.getAttribute('data-position');
        if(inputcurrentFitment !== 'Cargo mat'){
          const input = row.querySelector('input[type="checkbox"], input[type="radio"]');

          if (input && input !== currentInput) {
            input.checked = false;
            row.classList.remove('acitve-row-prod');
          }
        }
      });
    }

    if (currentInput.checked) {
      currentRow.classList.add('acitve-row-prod');
    }
  }
  
  const positionSelectRow = event.target.closest('.position-select-row');
  const quantityUpdate = event.target.closest('.quantity-selector');
  if (quantityUpdate && event.target.tagName === 'INPUT') {
    updateTotalPrice();
  }
  if(document.querySelector('.product-info__gettitle')){
    shopify_product_id = document.querySelector('.product-info__gettitle').getAttribute('data-pid');
    if (positionSelectRow && event.target.tagName === 'INPUT') {
      const row_product_title = event.target.value;
      const row_product_console = event.target?.getAttribute('data-consolecover');
      const row_product_fitval = event.target?.getAttribute('data-fitment-val');
      const row_product_fitimg = event.target?.getAttribute('data-fitment-img');
      const row_product_price = event.target?.getAttribute('data-sprice');
      const row_product_cprice = event.target?.getAttribute('data-cprice');
      const row_product_sku = event.target?.getAttribute('data-sku');
      const rowContainer = event.target.closest('.product-info__rowindex');
      const row_index = rowContainer?.getAttribute('data-row-index');

      rowContainer.classList.add('acitve-row-prod');
      rowContainer?.setAttribute('data-selectstyle',row_product_title);
      rowContainer?.setAttribute('data-selectfit',row_product_fitval);
      rowContainer?.setAttribute('data-fitimage',row_product_fitimg);
      rowContainer?.setAttribute('data-consolecover',row_product_console);
      rowContainer?.setAttribute('data-price',row_product_price);
      rowContainer?.setAttribute('data-cprice',row_product_cprice);
      rowContainer?.setAttribute('data-sku',row_product_sku);

      if(row_product_console){
        if(rowContainer.nextElementSibling?.classList.contains('product-info__consolecover') && row_product_console == "true"){
          rowContainer.nextElementSibling?.classList.remove('hide-console-cover');
        }else{
          rowContainer.nextElementSibling?.classList.add('hide-console-cover');
        }
      }else{
        if(rowContainer.nextElementSibling){
          rowContainer.nextElementSibling?.classList.add('hide-console-cover');
        }
      }
      updateTotalPrice();
      updateATCButtonState();
      const selectedSwatch = event.target.nextElementSibling;
      if (event.target.checked && selectedSwatch) syncSwatchProperties(selectedSwatch);
    }
  }
});
document.addEventListener("click", function (event) {
  const button = event.target.closest(".fit-dropdown-button");
  if (!button) return; // Click not on a .fit-dropdown-button

  const container = button.closest(".dropdown-container");
  const dropdown = container?.querySelector(".pro-dropdown-menu");
  const isActive = button.classList.contains("active");

  document.querySelectorAll(".fit-dropdown-button").forEach(btn => {
    btn.classList.remove("active");
    const parentContainer = btn.closest(".dropdown-container");
    const menu = parentContainer?.querySelector(".pro-dropdown-menu");
    if (menu) menu.classList.remove("show");
  });

  if (!isActive && dropdown) {
    button.classList.add("active");
    dropdown.classList.add("show");
  }
});

document.addEventListener("click", function (event) {
  const li = event.target.closest(".pro-dropdown-menu ul li");
  if (!li) return;
  event.preventDefault(); // Prevents unwanted input focus or default behavior
  const labelText = li.textContent.trim();
  selectOption(li, labelText);
});
document.addEventListener('change', event => {
  const input = event.target.closest('.meta-option-color .variant-opt-change');
  if (!input) return;
  const colorContainer = input.closest('.meta-option-color');
  const summary = colorContainer.querySelector('.variant-picker__option-info span');
  if (summary) summary.textContent = input.value;
  const property = document.getElementById('selected-color-property');
  if (property) property.value = input.value;
  const image = input.dataset.productImage;
  if (image) document.querySelectorAll('.product-gallery__thumbnail[data-image-meta]').forEach(button => {
    if (button.dataset.imageMeta === image) button.click();
  });
});

document.addEventListener('click', function (e) {
  const clickedLabel = e.target.closest('.product-grid-fitmentwrapper label');
  if (clickedLabel) {
    const containerFields = document.querySelectorAll('.product-grid-fitmentwrapper .product-grid-wrap.product-info__block-item:not(.product-info__consolecover)')
    containerFields.forEach(element => element.classList.remove('ymm-check-error'));

    const radioId = clickedLabel.getAttribute('for');
    const radio = document.getElementById(radioId);
    if (radio && radio.type === 'radio' && !radio.checked) {
      e.preventDefault(); // prevent default focus and scroll
      clickedLabel.blur();    // remove focus immediately
      radio.checked = true;

      const swatch = radio.nextElementSibling;
      if (!swatch) return;
      const fitmentWrap = swatch.querySelector('.fitment-section-wrapp');
      if (fitmentWrap) {
        const dropdownItems = fitmentWrap.querySelectorAll('.pro-dropdown-menu li');
        const dropdownTitleEl = fitmentWrap.querySelector('.fit-dropdown-button .dropdown-title');
        const dropdownTitle = dropdownTitleEl?.textContent?.trim();
        if (dropdownItems.length > 1) {
          if (dropdownTitle === 'Choose option' || dropdownTitle == 'Select Fitment') {
            swatch.classList.remove('active-swatch');
          } else {
            swatch.classList.add('active-swatch');
          }
        } else {
          swatch.classList.add('active-swatch');
        }
      }
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      if (swatch && swatch.classList.contains('active-swatch')) {
        syncSwatchProperties(swatch);
      }
    }
    if (radio && radio.matches('.product-info__consolecover .sr-only[type="radio"], .product-info__consolecover .sr-only[type="checkbox"]')) {
      setTimeout(() => {
        if (radio.checked) {
          radio.closest('.variant-picker__option').querySelector('.variant-picker__option-info span').innerText = radio.nextElementSibling.querySelector('p').innerText
          const container = radio.closest('.product-info__consolecover');
          if (container) {
            let selectedColorEl = '';
            if(document.querySelector('.variant-picker__option.var_color')){
              selectedColorEl = document.querySelector('.variant-picker__option.var_color .variant-picker__option-info .selected-opt-value');
            }else{
              selectedColorEl = document.querySelector('.variant-picker__option.var_console-cover .variant-picker__option-info .selected-opt-value');
            }
            if (selectedColorEl) {
              const SelectedColor = selectedColorEl.innerText.trim();
              const SelectOpt = document.querySelector('#variant-select-option');

              if (!SelectOpt) {
                console.warn("Variant select element not found");
                return;
              }
              let combinedNo, combinedYes;
              if (SelectedColor.trim() === "No Console") {
                combinedNo = `No Console`;
                combinedYes = `With Console Cover`;
              } else {
                combinedNo = `${SelectedColor} / No Console`;
                combinedYes = `${SelectedColor} / With Console Cover`;
              }
              const matchingOption = Array.from(SelectOpt.options).find(opt => opt.text.trim() === combinedNo);
              const matchingOptionYes = Array.from(SelectOpt.options).find(opt => opt.text.trim() === combinedYes);
              const PriceOpt = matchingOption?.dataset.price || null;
              const CpriceOpt = matchingOption?.dataset.comprice || null;
              const PriceOptYes = matchingOptionYes?.dataset.price || null;
              const CpriceOptYes = matchingOptionYes?.dataset.comprice || null;
              const priceDifference = PriceOptYes - PriceOpt;
              const comparePriceDifference = CpriceOptYes - CpriceOpt;
              const savedPrice = priceDifference > 0 ? priceDifference : 0;
              const savedComparePrice = comparePriceDifference > 0 ? comparePriceDifference : 0;

              SelectOpt.setAttribute('main-price-select',PriceOpt);
              SelectOpt.setAttribute('main-price-compare',CpriceOpt);
              SelectOpt.setAttribute('console-price-select',savedPrice);
              SelectOpt.setAttribute('console-price-compare',savedComparePrice);
              document.querySelectorAll('.product-info__block-item.product-info__consolecover').forEach(block => {
                const yesInput = block.querySelector('.console-select-row input[value="Yes"]');
                if (yesInput) {
                  yesInput.setAttribute('data-price-select',savedPrice);
                  yesInput.setAttribute('data-price-cselect',savedComparePrice);
                  yesInput.nextElementSibling.querySelector('.console-price').innerText = window.$money_format(savedPrice, window.$shop_money_format);
                }
              });
              document.querySelectorAll('.product-info__consolecover.atc-product-variant').forEach(container => {
                const selectedInput = container.querySelector('input.sr-only:checked');
                const prevEl = container.previousElementSibling;

                if (!selectedInput || !prevEl) return;
                const isYes = selectedInput.value === 'Yes';
                const variant = isYes ? matchingOptionYes : matchingOption;

                if (variant) {
                  prevEl.setAttribute('data-addvar', variant.value);
                  prevEl.setAttribute('data-price', isYes ? PriceOptYes : PriceOpt);
                  prevEl.setAttribute('data-cprice', isYes ? CpriceOptYes : CpriceOpt);
                } else {
                  console.warn("No variant found for", isYes ? combinedYes : combinedNo);
                }
              });
            }
            container.dataset.selectvar = radio.value;
            container.dataset.price = radio.dataset.priceSelect;
            container.dataset.cprice = radio.dataset.priceCselect;
            updateTotalPrice();
            updateATCButtonState();
          }
        }
      }, 0);
    }
  }
});


if (!customElements.get('max-height')) {
  class MaxHeight extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.max-height--inner-content');
      this.toggle = this.querySelector('.max-height--toggle');
      this.max = this.dataset.max;
    }

    connectedCallback() {
      if (!this.content || !this.toggle) return;
      this.clickHandler ||= this.onClick.bind(this);
      this.resizeHandler ||= this.checkVisible.bind(this);
      this.toggle.addEventListener('click', this.clickHandler);
      window.addEventListener('resize', this.resizeHandler);

      this.checkVisible();
    }

    disconnectedCallback() {
      this.toggle?.removeEventListener('click', this.clickHandler);
      window.removeEventListener('resize', this.resizeHandler);
    }
    checkVisible() {
      if (!this.content) return;
      if (this.content.offsetHeight > this.max) {
        this.showToggle();
      } else {
        this.hideToggle();
      }
    }
    showToggle() {
      this.classList.add('max-height--active');
    }
    hideToggle() {
      this.classList.remove('max-height--active');
    }
    onClick() {
      this.classList.toggle('max-height--enabled');
    }
  }
  customElements.define('max-height', MaxHeight);
}

document.addEventListener('change', event => {
  if (!event.target.matches('[id="custom-embroidery"]')) return;
  document.querySelector('.custom_embroidery_section')?.classList.toggle('default_hide_section', !event.target.checked);
});

document.addEventListener('click', function (e) {
  const btn = e.target.closest(
    '.shopify-product-form .buy-buttons button[type="submit"].disabled'
  );

  if (!btn) return;

  e.preventDefault();
  e.stopImmediatePropagation();
  e.stopPropagation();

  const form = btn.closest('.shopify-product-form');
  if (!form) return;

  if (form.querySelector('.atc-error-message')) return;

  const msg = document.createElement('div');
  msg.className = 'atc-error-message';

  if(btn.classList.contains('disabledchoose')){
    msg.textContent = 'Select your fitment before adding to cart.';
  }else{
    const containerFields = document.querySelectorAll('.product-grid-fitmentwrapper .product-grid-wrap.product-info__block-item:not(.product-info__consolecover)')
    containerFields.forEach(element => element.classList.add('ymm-check-error'));
    msg.textContent = 'Please select Vehicle Fitment before adding to cart.';
  }
  

  btn.parentNode.insertBefore(msg, btn);

  setTimeout(() => {
    msg.remove();
  }, 3000);
}, true); 


document.addEventListener('change', function (e) {
  if (e.target.matches('.variant-picker__option-values input')) {
    updateATCButtonState();
  }
  setTimeout(function () {
    const buttons = document.querySelectorAll('.disable-button-load');
    buttons.forEach(button => {
      button.classList.remove('disable-button-load');
    });
  }, 1000);
});
onReady(function () {
  setTimeout(function () {
    const buttons = document.querySelectorAll('.disable-button-load');
    buttons.forEach(button => {
      button.classList.remove('disable-button-load');
    });
  }, 1000);
});
// Refresh after vehicle/option handlers, before theme click/submit handlers,
// and when an app replaces its hidden fields or a product form.
document.addEventListener('change', () => queueMicrotask(syncVehicleCartProperties));
document.addEventListener('click', event => {
  if (event.target.closest('.shopify-product-form button[type=submit], form[action*="/cart/add"] button[type=submit]')) syncVehicleCartProperties();
}, true);
document.addEventListener('submit', event => {
  if (!productForms().includes(event.target)) return;
  syncVehicleCartProperties();
  const button = event.submitter || event.target.querySelector('button[type=submit]');
  if (button?.classList.contains('disabled')) {
    event.preventDefault();
    event.stopImmediatePropagation();
    button.click();
  }
}, true);
document.addEventListener('formdata', event => {
  if (!productForms().includes(event.target)) return;
  for (const [key, value] of Object.entries(vehicleProperties())) {
    event.formData.delete(`properties[${key}]`);
    if (value) event.formData.set(`properties[${key}]`, value);
  }
}, true);
onReady(() => {
  syncVehicleCartProperties();
  const observer = new MutationObserver(records => {
    const relevant = records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
      node.nodeType === 1 && (node.matches('.gpo-hidden-inputs, form, input[name^="properties["]') ||
        node.querySelector('.gpo-hidden-inputs, form'))));
    if (relevant) syncVehicleCartProperties();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});

// Submission protection: embroidery/GPO may change the button's CSS classes.
// Window capture validates before document/form click handlers build cart items.
function checkFitmentBeforeCart(event) {
  if (!(event.target instanceof Element)) return;
  if (window.location.href.toLowerCase().includes('retractable-shade')) return;

  const formSelector = 'form.shopify-product-form, .shopify-product-form form, form[action*="/cart/add"]';
  let button = null;
  let form = null;
  if (event.type === 'submit') {
    if (!event.target.matches(formSelector)) return;
    form = event.target;
    button = event.submitter || form.querySelector('button[type="submit"]');
  } else {
    button = event.target.closest(
      '.shopify-product-form button[type="submit"], form[action*="/cart/add"] button[type="submit"]'
    );
    if (!button) return;
    form = button.form || button.closest('form');
  }

  // Prefer the current form's product section over unrelated product forms.
  const section = (form || button)?.closest('.shopify-section');
  const wrapper = form?.querySelector('.product-grid-fitmentwrapper') ||
    section?.querySelector('.product-grid-fitmentwrapper') ||
    (!section ? document.querySelector('.product-grid-fitmentwrapper') : null);
  if (!wrapper) return;

  const error = prepareFitmentRowsForCart(wrapper);
  if (!error) {
    syncVehicleCartProperties();
    return;
  }

  event.preventDefault();
  event.stopImmediatePropagation();
  const messageHost = button?.parentElement || form || wrapper;
  messageHost.querySelectorAll('.atc-error-message').forEach(message => message.remove());
  const message = document.createElement('div');
  message.className = 'atc-error-message';
  message.setAttribute('role', 'alert');
  message.textContent = error;
  if (button && button.parentElement === messageHost) {
    messageHost.insertBefore(message, button);
  } else {
    messageHost.appendChild(message);
  }
  wrapper.querySelectorAll('.product-info__rowindex:not(.removed-row-data)').forEach(row => {
    row.classList.add('ymm-check-error');
  });
  if (button) button.setAttribute('aria-busy', 'false');
}
window.addEventListener('click', checkFitmentBeforeCart, true);
window.addEventListener('submit', checkFitmentBeforeCart, true);